import React from 'react'
import styled from '@emotion/styled'

import {GenericErrorImage} from '../../../foundation/illustrations/GenericErrorImage'
import {cssTheme} from '../../../themes'
import {linariaMq} from '../../../utils/breakpoints'

const APPROXIMATE_HEADER_FOOTER_HEIGHT = 140
const IMAGE_CONTAINER_WIDTH_MOBILE = 240
const IMAGE_CONTAINER_WIDTH_DESKTOP_XS = 320
const IMAGE_CONTAINER_WIDTH_DESKTOP_SM = 420
const IMAGE_CONTAINER_WIDTH_DESKTOP_MD = 520

interface Props {
  /** The body of the content */
  children: React.ReactChild | React.ReactChild[]
  /** Pass through classname to allow styles overrides */
  className?: string
  /** The combined height in pixels of the header and footer components. This is used to calculate the min-height of the error message. */
  headerFooterHeight?: number
  /** Whether the component should show the Illustration or not  */
  withIllustration?: boolean
}

interface StyleProps {
  headerFooterHeight: number
}

const FlexItemsContainer = styled.div<StyleProps>`
  height: calc(100vh - ${({headerFooterHeight}) => headerFooterHeight}px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ImageContainer = styled.div`
  width: ${IMAGE_CONTAINER_WIDTH_MOBILE}px;
  padding: ${cssTheme.layout.spacing.s700} 0px;
  ${linariaMq.desktopXs} {
    width: ${IMAGE_CONTAINER_WIDTH_DESKTOP_XS}px;
    padding: ${cssTheme.layout.spacing.s800} 0px;
  }
  ${linariaMq.desktopSm} {
    width: ${IMAGE_CONTAINER_WIDTH_DESKTOP_SM}px;
    padding: ${cssTheme.layout.spacing.s900} 0px;
  }
  ${linariaMq.desktopMd} {
    width: ${IMAGE_CONTAINER_WIDTH_DESKTOP_MD}px;
    padding: ${cssTheme.layout.spacing.s950} 0px;
  }
`

export const GenericError = ({
  children,
  headerFooterHeight = APPROXIMATE_HEADER_FOOTER_HEIGHT,
  withIllustration = false,
  className
}: Props) => (
  <FlexItemsContainer
    headerFooterHeight={headerFooterHeight}
    className={className}
  >
    {withIllustration && (
      <ImageContainer>
        <GenericErrorImage />
      </ImageContainer>
    )}
    {children}
  </FlexItemsContainer>
)
